"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorWithCode = void 0;
exports.createId = createId;
exports.getAbsoluteUrl = getAbsoluteUrl;
exports.createErr = createErr;
exports.getUrl = getUrl;
exports.getOrigin = getOrigin;
exports.getTextContent = getTextContent;
exports.getBase64Content = getBase64Content;
exports.getType = getType;
exports.has = has;
exports.getTimestamp = getTimestamp;
var uniqId_1 = __importDefault(require("licia/uniqId"));
var random_1 = __importDefault(require("licia/random"));
var startWith_1 = __importDefault(require("licia/startWith"));
var Url_1 = __importDefault(require("licia/Url"));
var convertBin_1 = __importDefault(require("licia/convertBin"));
var axios_1 = __importDefault(require("axios"));
var type_1 = __importDefault(require("licia/type"));
var has_1 = __importDefault(require("licia/has"));
var perfNow_1 = __importDefault(require("licia/perfNow"));
var now_1 = __importDefault(require("licia/now"));
var prefix = (0, random_1.default)(1000, 9999) + '.';
function createId() {
    return (0, uniqId_1.default)(prefix);
}
function getAbsoluteUrl(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
var ErrorWithCode = (function (_super) {
    __extends(ErrorWithCode, _super);
    function ErrorWithCode(code, message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.code = code;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return ErrorWithCode;
}(Error));
exports.ErrorWithCode = ErrorWithCode;
function createErr(code, message) {
    return new ErrorWithCode(code, message);
}
function getUrl() {
    var href = location.href;
    if ((0, startWith_1.default)(href, 'about:')) {
        return parent.location.href;
    }
    return href;
}
function getOrigin() {
    var origin = location.origin;
    if (origin === 'null') {
        return parent.location.origin;
    }
    return origin;
}
function getTextContent(url_1) {
    return __awaiter(this, arguments, void 0, function (url, proxy) {
        if (proxy === void 0) { proxy = ''; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getContent(url, 'text', proxy)];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
function getBase64Content(url_1) {
    return __awaiter(this, arguments, void 0, function (url, proxy) {
        var _a;
        if (proxy === void 0) { proxy = ''; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = convertBin_1.default;
                    return [4, getContent(url, 'arraybuffer', proxy)];
                case 1: return [2, _a.apply(void 0, [_b.sent(), 'base64'])];
            }
        });
    });
}
function getType(val, lowerCase) {
    try {
        return type_1.default.apply(null, [val, lowerCase]);
    }
    catch (e) {
        return 'Error';
    }
}
function has(obj, key) {
    try {
        return has_1.default.apply(null, [obj, key]);
    }
    catch (e) {
        return false;
    }
}
function getTimestamp() {
    if (window.performance && performance.timeOrigin) {
        return performance.timeOrigin + (0, perfNow_1.default)();
    }
    return (0, now_1.default)();
}
function getContent(url_1, responseType_1) {
    return __awaiter(this, arguments, void 0, function (url, responseType, proxy) {
        var urlObj, result, e_1, result, e_2;
        if (proxy === void 0) { proxy = ''; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 8]);
                    urlObj = new Url_1.default(url);
                    urlObj.setQuery('__chobitsu-hide__', 'true');
                    return [4, axios_1.default.get(urlObj.toString(), {
                            responseType: responseType,
                        })];
                case 1:
                    result = _a.sent();
                    return [2, result.data];
                case 2:
                    e_1 = _a.sent();
                    if (!proxy) return [3, 7];
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 6, , 7]);
                    return [4, axios_1.default.get(proxyUrl(proxy, url), {
                            responseType: responseType,
                        })];
                case 4:
                    result = _a.sent();
                    return [4, result.data];
                case 5: return [2, _a.sent()];
                case 6:
                    e_2 = _a.sent();
                    return [3, 7];
                case 7: return [3, 8];
                case 8: return [2, responseType === 'arraybuffer' ? new ArrayBuffer(0) : ''];
            }
        });
    });
}
function proxyUrl(proxy, url) {
    var urlObj = new Url_1.default(proxy);
    urlObj.setQuery('url', url);
    urlObj.setQuery('__chobitsu-hide__', 'true');
    return urlObj.toString();
}
